import React from 'react';
import { useOutreachAccess } from '../../../hooks/CRM/useOutreach';
import PlatformFeatureGate from '../../Reusables/PlatformFeatureGate/PlatformFeatureGate';
import { useLeadPermissions } from './LeadWorkspace';

/**
 * The Outreach tracker needs the platform switch on for this company, a plan with leads, and the
 * Leads read permission.
 */
const OutreachGate = ({ children }) => {
	const { companyId, canRead } = useLeadPermissions();
	const access = useOutreachAccess(canRead ? companyId : null);
	return (
		<PlatformFeatureGate access={access} isAllowed={canRead}>
			{children}
		</PlatformFeatureGate>
	);
};

export default OutreachGate;
